<template>
  <div>
    <!-- Hero 区域 -->
    <header class="hero-gradient text-white pt-16 pb-24">
      <div class="max-w-[1440px] mx-auto px-6 flex flex-col items-center text-center">
        <h1 class="text-4xl md:text-5xl font-bold mb-4">一站式解决各种债权债务问题</h1>
        <p class="text-xl text-blue-100 mb-8 opacity-90">让每一笔债权都有其应有的价值</p>
        
        <!-- 搜索框 -->
        <div class="w-full max-w-3xl bg-white p-2 rounded-2xl shadow-2xl flex items-center">
          <div class="flex-1 flex items-center px-4">
            <IconifyIcon class="text-slate-400 text-2xl mr-2" icon="mdi:magnify" />
            <input 
              v-model="searchKeyword"
              @keyup.enter="handleSearch"
              class="w-full h-12 text-slate-800 outline-none" 
              placeholder="输入债务人姓名、企业名称或搜索法律问题..." 
              type="text"
            />
          </div>
          <div class="hidden md:flex items-center px-4 border-l border-slate-100">
            <el-select 
              v-model="selectedCategory" 
              placeholder="全部分类" 
              size="small"
              class="category-select"
            >
              <el-option
                v-for="item in categories"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <button 
            @click="handleSearch"
            class="bg-blue-600 text-white px-8 h-12 rounded-xl font-bold hover:bg-blue-700 transition"
          >
            立即搜索
          </button>
        </div>
        
        <!-- 数据快报 -->
        <div class="flex space-x-12 mt-12">
          <div class="text-center">
            <div class="text-3xl font-bold">￥{{showNumber.deal_amount||0}}</div>
            <div class="text-blue-200 text-sm mt-1">累计撮合金额</div>
          </div>
          <div class="text-center">
            <div class="text-3xl font-bold">{{showNumber.enter_company||0}}</div>
            <div class="text-blue-200 text-sm mt-1">入驻债权人</div>
          </div>
          <div class="text-center">
            <div class="text-3xl font-bold">{{showNumber.entry_cuishou||0}}</div>
            <div class="text-blue-200 text-sm mt-1">专业催收机构</div>
          </div>
        </div>
      </div>
    </header>

    <!-- 核心功能导航 -->
    <main class="max-w-[1440px] mx-auto px-6 -mt-12">
      <section class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        <!-- 常见问题专业解答 -->
        <router-link 
          to="/faq?category=1" 
          class="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all group flex flex-col justify-between h-[220px] border border-transparent hover:border-blue-500"
        >
          <div>
            <IconifyIcon class="text-4xl text-blue-600 mb-4" icon="mdi:message-question" />
            <h3 class="text-xl font-bold text-slate-800 mb-2 group-hover:text-blue-600">常见债权债务解答</h3>
            <p class="text-slate-500 text-sm leading-relaxed">专业律师团队为您提供债权债务相关的法律法规深度解析。</p>
          </div>
          <div class="flex items-center text-blue-600 text-sm font-medium">
            立即阅读 <IconifyIcon class="ml-1" icon="mdi:arrow-right" />
          </div>
        </router-link>

        <!-- 诉讼主张常见问题 -->
        <router-link 
          to="/faq?category=2" 
          class="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all group flex flex-col justify-between h-[220px] border border-transparent hover:border-blue-600"
        >
          <div>
            <IconifyIcon class="text-4xl text-purple-600 mb-4" icon="mdi:gavel" />
            <h3 class="text-xl font-bold text-slate-800 mb-2 group-hover:text-blue-600">诉讼主张常见问题</h3>
            <p class="text-slate-500 text-sm leading-relaxed">涵盖起诉证据准备、时效计算、诉讼策略等关键环节咨询。</p>
          </div>
          <div class="flex items-center text-blue-600 text-sm font-medium">
            查看详情 <IconifyIcon class="ml-1" icon="mdi:arrow-right" />
          </div>
        </router-link>

        <!-- 执行案件常见问题 -->
        <router-link 
          to="/faq?category=3" 
          class="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all group flex flex-col justify-between h-[220px] border border-transparent hover:border-red-600"
        >
          <div>
            <IconifyIcon class="text-4xl text-red-600 mb-4" icon="mdi:clipboard-check" />
            <h3 class="text-xl font-bold text-slate-800 mb-2 group-hover:text-blue-600">执行案件常见问题</h3>
            <p class="text-slate-500 text-sm leading-relaxed">针对执行难、财产查控、强制执行程序等难点提供指导。</p>
          </div>
          <div class="flex items-center text-blue-600 text-sm font-medium">
            了解更多 <IconifyIcon class="ml-1" icon="mdi:arrow-right" />
          </div>
        </router-link>

        <!-- 在线客服答疑 -->
        <router-link 
          to="/customer-service" 
          class="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all group flex flex-col justify-between h-[220px] border border-transparent hover:border-green-500"
        >
          <div>
            <IconifyIcon class="text-4xl text-green-600 mb-4" icon="mdi:headset-customer-service" />
            <h3 class="text-xl font-bold text-slate-800 mb-2 group-hover:text-blue-600">在线客服答疑</h3>
            <p class="text-slate-500 text-sm leading-relaxed">全天候在线法律顾问，即时解答您的个性化债权纠纷问题。</p>
          </div>
          <div class="flex items-center text-blue-600 text-sm font-medium">
            立即咨询 <IconifyIcon class="ml-1" icon="mdi:arrow-right" />
          </div>
        </router-link>

        <!-- 债权债务交易信息展示 -->
        <router-link 
          to="/square" 
          class="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all group flex flex-col justify-between h-[220px] border border-transparent hover:border-orange-500"
        >
          <div>
            <IconifyIcon class="text-4xl text-orange-600 mb-4" icon="mdi:chart-timeline-variant" />
            <h3 class="text-xl font-bold text-slate-800 mb-2 group-hover:text-blue-600">债权债务交易展示</h3>
            <p class="text-slate-500 text-sm leading-relaxed">实时公示最新的债权转让、债务托管及撮合进度信息。</p>
          </div>
          <div class="flex items-center text-blue-600 text-sm font-medium">
            进入广场 <IconifyIcon class="ml-1" icon="mdi:arrow-right" />
          </div>
        </router-link>

        <!-- 代写文书 -->
        <router-link 
          to="/legal-docs" 
          class="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all group flex flex-col justify-between h-[220px] border border-transparent hover:border-indigo-500"
        >
          <div>
            <IconifyIcon class="text-4xl text-indigo-600 mb-4" icon="mdi:file-document-edit" />
            <h3 class="text-xl font-bold text-slate-800 mb-2 group-hover:text-blue-600">专业代写文书</h3>
            <p class="text-slate-500 text-sm leading-relaxed">代写民事诉状、合同协议、律师函等专业法律文书。</p>
          </div>
          <div class="flex items-center text-blue-600 text-sm font-medium">
            申请代写 <IconifyIcon class="ml-1" icon="mdi:arrow-right" />
          </div>
        </router-link>

        <!-- 定制专属文案 -->
        <router-link 
          to="/customer-service?service=copywriting" 
          class="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all group flex flex-col justify-between h-[220px] border border-transparent hover:border-pink-500"
        >
          <div>
            <IconifyIcon class="text-4xl text-pink-600 mb-4" icon="mdi:star-face" />
            <h3 class="text-xl font-bold text-slate-800 mb-2 group-hover:text-blue-600">定制专属文案</h3>
            <p class="text-slate-500 text-sm leading-relaxed">为您量身定制更具法律效力与压制力的债权公示与催告文案。</p>
          </div>
          <div class="flex items-center text-blue-600 text-sm font-medium">
            立即定制 <IconifyIcon class="ml-1" icon="mdi:arrow-right" />
          </div>
        </router-link>

        <!-- 快速发布入口 -->
        <router-link 
          to="/publish" 
          class="bg-blue-600 p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all group flex flex-col justify-between h-[220px]"
        >
          <div>
            <IconifyIcon class="text-4xl text-white mb-4" icon="mdi:plus-circle" />
            <h3 class="text-xl font-bold text-white mb-2">快速发布需求</h3>
            <p class="text-blue-100 text-sm leading-relaxed">一键上传您的债权信息或债务优化申请，极速对接专家。</p>
          </div>
          <div class="flex items-center text-white text-sm font-medium">
            立即发布 <IconifyIcon class="ml-1" icon="mdi:arrow-right" />
          </div>
        </router-link>
      </section>

      <!-- 债权信息入口（精简展示） -->
      <div class="bg-white rounded-2xl shadow-sm p-8 mb-12">
        <div class="flex items-center justify-between mb-8">
          <div>
            <h2 class="text-2xl font-bold flex items-center">
              <IconifyIcon class="text-yellow-500 mr-2" icon="mdi:lightning-bolt" /> 
              最新交易信息
            </h2>
            <p class="text-slate-500 text-sm mt-1">今日新增 {{ newCount }} 条债权公示</p>
          </div>
          <router-link to="/square" class="text-blue-600 hover:underline flex items-center text-sm font-medium">
            进入信息广场查看全部 <IconifyIcon class="ml-1" icon="mdi:arrow-right" />
          </router-link>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div 
            v-for="(item, index) in claims" 
            :key="index"
            class="border border-slate-100 rounded-xl p-5 hover:shadow-lg transition cursor-pointer group"
            @click="goToDetail(item)"
          >
            <div class="flex justify-between items-start mb-4">
              <span class="bg-blue-50 text-blue-600 text-xs px-2 py-1 rounded">{{ item.type_name }}</span>
              <span class="text-slate-400 text-xs">{{ item.date }}</span>
            </div>
            <h3 class="font-bold text-slate-800 mb-1 group-hover:text-blue-600">{{ item.title }}</h3>
            <div class="text-sm text-slate-500 mb-4 flex items-center">
              <IconifyIcon icon="mdi:map-marker-outline" class="mr-1" /> 
              {{ item.region }}
            </div>
            <div class="flex items-end justify-between border-t border-slate-50 pt-4">
              <div>
                <div class="text-xs text-slate-400">债权金额</div>
                <div class="text-xl font-bold text-orange-600">￥{{ item.amount }}</div>
              </div>
              <IconifyIcon icon="mdi:chevron-right" class="text-slate-300 text-2xl" />
            </div>
          </div>
        </div>
      </div>

      <!-- FAQ 入口 -->
      <section class="pb-20">
        <div class="bg-slate-900 rounded-3xl p-10 text-white flex flex-col md:flex-row items-center justify-between">
          <div class="mb-8 md:mb-0">
            <h2 class="text-3xl font-bold mb-4">有疑问？查看我们的帮助中心</h2>
            <p class="text-slate-400">涵盖了债权公示、支付安全、法律合规等100+核心问题。</p>
          </div>
          <div class="flex space-x-4">
            <router-link to="/faq?category=1" class="bg-white text-slate-900 px-8 py-3 rounded-xl font-bold hover:bg-slate-100 transition">
              前往常见问题
            </router-link>
            <router-link to="/customer-service" class="bg-blue-600 text-white px-8 py-3 rounded-xl font-bold hover:bg-blue-700 transition">
              联系在线客服
            </router-link>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { getIndex } from '@/api/index'
export default {
  name: 'Home',
  data() {
    return {
      searchKeyword: '',
      selectedCategory: '',
      showNumber:{},
      categories: [],
      claims: [],
      newCount:0,
    }
  },
  created() {
    this.getIndexInfo()
  },
  methods: {
    // 获取首页数据
    async getIndexInfo(){
      const res = await getIndex()
      if(res.status==200){
        this.showNumber = res.data.show_number
        this.claims = res.data.new_debt
        this.newCount = res.data.today_add_num
        this.categories = res.data.search_type
      }
    },
    handleSearch() {
      this.$router.push({
        path: '/search-list',
        query: { keyword: this.searchKeyword ,type:this.selectedCategory}
      })
    },
    goToDetail(item) {
      this.$router.push({
        path: '/detail',
        query: { id: item.id }
      })
    }
  }
}
</script>

<style scoped>
/* Element UI 下拉选择器样式调整 */
.category-select {
  width: 100px;
}

.category-select >>> .el-input__inner {
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  padding-left: 0;
  padding-right: 20px;
}

.category-select >>> .el-input__suffix {
  right: 0;
}

.category-select >>> .el-input__icon {
  color: #94a3b8;
}
</style>
